import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';

const FilesApi = [rest.get(`${API_ROOT}files`, (req, res, ctx) => res(ctx.json([])))];
export default FilesApi;
